import { ChangeDetectorRef, Component, forwardRef, Inject, ViewChild } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, Platform, Searchbar, Events, ToastController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from '../../services/ebsWebServiceGlobals';
import { Detail } from "../detail/detail";
declare var $;

import { Vibration } from '@ionic-native/vibration';

@IonicPage()
@Component({
  selector: 'page-grid-box',
  templateUrl: 'grid-box.html',
})
export class GridBoxPage {

  title: any;
  contentTitle: string = "";
  data: any;
  moreItemsAvailable: boolean = false;
  loadMoreURL: string = "";
  loadMoreParams: string = "";
  searchword: string = "";
  showSpinner: boolean = false;
  beforeSearchData: any;
  selectedItems: any = [];
  actionForSelectedItems: any;
  actionButtonNameForSelectedItems = "";
  showPrevBtn: boolean = false;
  showNextBtn: boolean = false;
  showSelectAllBtn: boolean = false;
  allowSearchScan: boolean = false;

  checkCancelDynamic: boolean = false;
  showAltCancelBtn: boolean = false;
  altCancelValue: any;

  checkFinishDynamic: boolean = false;
  showAltFinishBtn: boolean = false;
  altFinishValue: any;

  filterButtons: any = [];
  filterButtonsCollapsed: boolean;
  filterButtonsCollapsedButtonDegree: number;

  private showQRCODE = true;

  @ViewChild("searchbar") searchbar: Searchbar;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public platform: Platform,
    public events: Events,
    private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    public ebsWebserviceGlobals: EbsWebServiceGlobals,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private cdRef: ChangeDetectorRef,
    private vibration: Vibration) {

    console.log(`grid-box.ts [navParams]=[${JSON.stringify(navParams)}]`);

    if (typeof this.navParams.get("filterButtonsCollapsed") != "undefined" && this.navParams.get("filterButtonsCollapsed") != null) { // remember if collapsed after navigation
      this.filterButtonsCollapsed = this.navParams.get("filterButtonsCollapsed");
    } else { // default collapsed if mobile
      this.filterButtonsCollapsed = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    this.filterButtonsCollapsedButtonDegree = this.filterButtonsCollapsed ? 0 : 180;

    if (this.platform.is('core') || this.platform.is('mobileweb')) {
      this.showQRCODE = false;
    }
    //events.publish("reloadMenu");

    if (typeof this.navParams.get("searchresult") != "undefined" && this.navParams.get("searchresult") != null) {
      this.data = this.navParams.get("searchresult");
      this.beforeSearchData = this.data;
      this._ebsWebService.setBrowserTabTitle(this.data.MainTitle);
      this.title = this.data.Caption;
    } else {
      if (typeof this.navParams.get('actionURL') != "undefined") {
        let loading = this.loadingCtrl.create({
          content: 'Bitte warten...'
        });
        loading.present();
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));

        this._ebsWebService.postData(navParams.get('actionURL'), postPayloadObject).subscribe(res => {
          if (typeof res != "undefined" && res != null) {
            if (res.ViewType == "Detail") {
              loading.dismiss();
              let actionCaption = "test";
              if (res.ListItemNavigation[0].ActionCaption && res.ListItemNavigation[0].ActionCaption != null) {
                actionCaption = res.ListItemNavigation[0].ActionCaption;
              }

              if (this.navCtrl != null && this.navCtrl && Detail != null && Detail) {
                if (res.ListItemNavigation[0].Action && res.ListItemNavigation[0].PostParameters) {
                  navCtrl.push(Detail, {
                    title: actionCaption,
                    actionURL: res.ListItemNavigation[0].Action,
                    postParams: res.ListItemNavigation[0].PostParameters
                  });
                }
              }
            } else {
              this.data = res;
              this.beforeSearchData = this.data;

              if (res.Dynamic != null && typeof res.Dynamic.CustomMainTitle != "undefined" && res.Dynamic.CustomMainTitle != null) {
                this.title = res.Dynamic.CustomMainTitle;
              } else {
                this.title = res.MainTitle;
              }

              if (res.Dynamic != null && res.Dynamic.FilterButtons != null) {
                this.filterButtons = JSON.parse(res.Dynamic.FilterButtons);
              }

              if (res.Dynamic != null) {
                if (typeof res.Dynamic.ContentTitle != "undefined" && res.Dynamic.ContentTitle != null) {
                  this.contentTitle = res.Dynamic.ContentTitle;
                }

                if (res.Dynamic.PrevBtn == "True" && res.Dynamic.PrevBtn != null) {
                  this.showPrevBtn = true;
                }

                if (res.Dynamic.NextBtn == "True" && res.Dynamic.NextBtn != null) {
                  this.showNextBtn = true;
                }

                if (res.Dynamic.SelectAllBtn == "True" && res.Dynamic.SelectAllBtn != null) {
                  this.showSelectAllBtn = true;
                }

                if (res.Dynamic.AltCancelBtn == "True" && res.Dynamic.AltCancelBtn != null) {
                  this.checkCancelDynamic = true;
                }

                if (res.Dynamic.AltFinishBtn == "True" && res.Dynamic.AltFinishBtn != null) {
                  this.checkFinishDynamic = true;
                }

                if (res.Dynamic.AllowSearchScan == "True" && res.Dynamic.AllowSearchScan != null) {
                  this.allowSearchScan = true;
                }
              }
              console.log("grid res");
              console.log(res);
              console.log("grid res");

              this._ebsWebService.setBrowserTabTitle(res.MainTitle);
              this.checkIfAtLeastOneItemIsSelected(res.ListItemNavigation);
              this.getListItemActionForSelection(res.ListItemAction);
              this.checkIfCancel(res.ListItemNavigation);
              this.checkIfFinish(res.ListItemNavigation);
              this.cdRef.detectChanges();
              loading.dismiss();
            }
          }
        }, err => {
          loading.dismiss();
          navCtrl.pop();
          this.errorToast();
        });

      }
    }
  }

  openPage(element) {
    console.log(element);
    let navParams = {
      title: element.Caption,
      actionURL: element.Action,
      postParams: element.PostParameters,
      caption: element.Caption
    };
    this._ebsComponentService.navigationController(element, navParams, this.navCtrl);
  }

  checkIfCancel(items) {
    if (this.checkCancelDynamic) {
      let count = 0;
      items.forEach(item => {
        count++;
        if (item.PostParameters.includes("param1=CANCEL") || item.PostParameters.includes("param1=DELETE")) {
          this.altCancelValue = item;
          items.splice(count - 1, 1);
          this.showAltCancelBtn = true;
        }
      });
    }
  }

  checkIfFinish(items) {
    if (this.checkFinishDynamic) {
      let count = 0;
      items.forEach(item => {
        count++;
        if (item.PostParameters.includes("param1=FINISH")) {
          this.altFinishValue = item;
          //items.splice(count -1, 1);
          this.showAltFinishBtn = true;
        }
      });
    }
  }

  checkIfAtLeastOneItemIsSelected(items) {
    if (items) {
      items.forEach(item => {
        if (item.IsSelected) {
          if (this.selectedItems.indexOf(item.ID) == -1) {
            this.selectedItems.push(item.ID);
          }
        }
      });
    }
  }

  getListItemActionForSelection(actions) {
    if (actions) {
      actions.forEach(action => {
        if (action.ActionName == "SelectionFinished") {
          this.actionForSelectedItems = action;
          this.actionButtonNameForSelectedItems = action.DisplayName;
        }
      });
    }
  }

  checkForPaging() {
    this.loadMoreURL = "";
    if (this.data.ListItemAction != null) {
      this.data.ListItemAction.forEach(element => {
        console.log(element.ActionName, 'actionname');
        if (element.ActionName === "Paging") {
          this.loadMoreURL = element.ActionUrl;
          this.loadMoreParams = element.PostParameters;
          this.moreItemsAvailable = true;
        } else {
          this.moreItemsAvailable = false;
        }
      });
    } else {
      this.moreItemsAvailable = false;
    }
  }

  ionViewWillLeave() {
    this.events.unsubscribe('data:scan', null);
  }

  ionViewDidEnter() {
    this.platform.ready().then(() => {
      this.events.subscribe('data:scan', (scanData) => {

        if (this.allowSearchScan == true) {
          let scannedData = scanData.extras["com.symbol.datawedge.data_string"];
          console.log("+++");
          console.log(scannedData);
          console.log("+++");
          this.searchword = scannedData;
          this.search();
          this.cdRef.detectChanges();
          this.vibration.vibrate([100]);
        }

      });
    });
  }

  ionViewDidLoad() {
    setTimeout(() => {
      if (typeof this.searchbar != "undefined" && !this.platform.is("tablet") && !this.platform.is("mobile")) {
        this.searchbar.setFocus();
      }
    }, 1000);

    this.events.subscribe('event:ItemSelected', (selectedItem) => {
      if (this.selectedItems.indexOf(selectedItem) == -1) {
        //console.log("event");
        //console.log(selectedItem);
        this.selectedItems.push(selectedItem);
      }
      this.cdRef.detectChanges();
    });

    this.events.subscribe('event:ItemDeselected', (deselectedItem) => {
      if (this.selectedItems.indexOf(deselectedItem) != -1) {
        for (var i = 0; i < this.selectedItems.length; i++) {
          if (this.selectedItems[i] === deselectedItem) {
            this.selectedItems.splice(i, 1);
            i--;
          }
        }

      }
      if (this.selectedItems.length == 0) {
        $(".scroll-content").css("margin-bottom", "0px");
      }
      this.cdRef.detectChanges();
    });
  }

  loadMore(event) {
    this.checkForPaging();
    setTimeout(() => {
      if (this.loadMoreURL != "") {
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.loadMoreParams);
        this._ebsWebService.postData(this.loadMoreURL, postPayloadObject).subscribe(res => {
          this.data.ListItemNavigation = this.data.ListItemNavigation.concat(res.ListItemNavigation);
        });
      }
      event.complete();
    }, 500);
  }

  loadMoreOnClick(loadMoreURL, postParams) {
    //console.log(loadMoreURL, 'url');
    //console.log(postParams, 'params');
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(postParams);
    this._ebsWebService.postData(loadMoreURL, postPayloadObject).subscribe(res => {
      this.data.ListItemAction = res.ListItemAction;
      this.data.ListItemNavigation = this.data.ListItemNavigation.concat(res.ListItemNavigation);
      console.log(this.data);
    });
  }

  errorToast() {
    let toast = this.toastCtrl.create({
      message: "Fehler beim Laden der Daten",
      duration: 3000,
      position: "bottom"
    });
    toast.present();
  }

  onSearchInput() {
    this.search();
  }

  search() {
    if (this.searchword.length > 1) {
      this.events.publish('event:DeselectAllItems');
      this.selectedItems = [];
      this.deselectAllItems();
      this.showSpinner = true;
      let parsedPostPayloadObject = JSON.parse(this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.data.SearchUrlPostParameters));
      parsedPostPayloadObject.searchWord = this.searchword;
      let postPayloadObject = JSON.stringify(parsedPostPayloadObject);
      this._ebsWebService.postData(this.data.SearchUrl, postPayloadObject).subscribe(res => {
        this.showSpinner = false;
        if (res.ViewType == "Detail") {
          this.navCtrl.push(Detail, {
            title: res.ListItemNavigation[0].ActionCaption,
            actionURL: res.ListItemNavigation[0].Action,
            postParams: res.ListItemNavigation[0].PostParameters
          });
        } else {
          res.ListItemNavigation.forEach(element => {
            this.events.publish('event:ItemSelected', element.ID);
          });
          this.data = res;
        }
        this.cdRef.detectChanges();
        setTimeout(() => { this.cdRef.detectChanges(); });

        if (this.allowSearchScan != true || this.data.ListItemNavigation[0].Action == null) {
          this.deselectAllItems();
        }

      });
      setTimeout(() => {
        this.showSpinner = false;
      }, 10000)
    } else {
      this.beforeSearchData.ListItemNavigation.forEach((item) => {
        item.IsSelected = false;
      });
      this.data = this.beforeSearchData;
    }
  }

  onSearchClear() {
    this.searchword = "";
    this.selectedItems = [];
    this.data = this.beforeSearchData;
  }

  openSelectedItems() {
    if (this.actionForSelectedItems.ActionUrl == null) {
      return;
    }
    let selectedItemsString = ";";
    this.selectedItems.forEach(item => {
      selectedItemsString = selectedItemsString + item + ";";
    });
    if (selectedItemsString.length <= 1) {
      return;
    }
    this.actionForSelectedItems.ActionParams = this.actionForSelectedItems.PostParameters + selectedItemsString;
    var navigationObject = {
      actionURL: this.actionForSelectedItems.ActionUrl,
      postParams: this.actionForSelectedItems.ActionParams,
    };
    this._ebsComponentService.navigationController(this.actionForSelectedItems, navigationObject, this.navCtrl);
  }

  deselectAllItems() {
    this.cdRef.detectChanges();
    this.selectedItems = [];
    this.events.publish('event:DeselectAllItems');
    $(".scroll-content").css("margin-bottom", "0px");
    this.cdRef.detectChanges();
  }

  selectAllItems() {
    console.log(this.selectedItems);
    $(".show-page:not([hidden])").find(".multi-select .item-cover[aria-checked='false']").click();
  }

  onFilterButton(item) {
    console.log('item', item);

    let split = item.Action.split("?");
    let url = split[0];
    let params = split[1];

    let navParams = {
      title: item.Caption,
      actionURL: url,
      postParams: params,
      filterButtonsCollapsed: this.filterButtonsCollapsed
    };

    console.log(params, 'params');
    console.log(this._ebsWebService.buildPostPayloadObjectFromGetParameters(params), 'params parsed');

    //this._ebsWebService.postData(url, this._ebsWebService.buildPostPayloadObjectFromGetParameters(params)).subscribe(res => {
    //  console.log(res);
    //});

    item.ActionType = "Pop";
    this._ebsComponentService.navigationController(item, navParams, this.navCtrl);
  }

  collapseFilterButtons() {
    this.filterButtonsCollapsed = !this.filterButtonsCollapsed;
    this.filterButtonsCollapsedButtonDegree += 180;
  }

  getFilterButtonsHeight() {
    let elements = document.getElementsByClassName('outer-button-wrapper');
    let lastElement = elements[elements.length - 1];
    let height;
    if (lastElement instanceof HTMLElement) {
      height = lastElement.offsetTop - 33;
    }
    return height;
  }

}



// WEBPACK FOOTER //
// ./src/pages/grid-box/grid-box.ts